<template>
    <div class="flex flex-col h-full w-full gap-2 px-2">
        <div class="flex flex-col h-0 grow w-full">
            <dx-tree-list
                width="100%"
                height="100%"
                ref="treeListRef"
                class="h-0 grow"
                column-resizing-mode="widget"
                :key-expr="meta.keyExpr"
                :parent-id-expr="meta.parentIdExpr"
                :data-source="datasrc"
                :allow-column-resizing="true"
                :allow-column-reordering="true"
                :column-min-width="70"
                :column-auto-width="meta.columnAutoWidth || true"
                v-model:expanded-row-keys="expandedRowKeys"
                :focused-row-enabled="meta.focusedRowEnabled"
                :focused-row-index="0"
                :hover-state-enabled="true"
                :root-value="meta.rootValue || null"
                :show-borders="true"
                :show-column-lines="true"
                :show-row-lines="true"
                :column-chooser="{ enabled: true, mode: 'select' }"
                :header-filter="{ visible: true }"
                :filter-panel="{ visible: true }"
                :filter-row="{ visible: true }"
                :fixing="{ enabled: true }"
                :load-panel="{ enabled: true }"
                :scrolling="{ mode: meta.scrollingMode || 'virtual' }"
                :paging="{ enabled: meta.isPagingEnabled || false }"
                :search-panel="{ visible: true, placeholder: 'Поиск...' }"
                :selection="{
                    mode: meta.selectionMode || 'multiple',
                    showCheckBoxesMode: meta.showCheckBoxesMode || 'always',
                    allowSelectAll: meta.allowSelectAll || false,
                    recursive: meta.recursiveSelection || false,
                }"
                @row-prepared="onRowPrepared"
                @content-ready="contentReady"
                @selection-changed="selectionChanged"
                @exporting="onExporting"
            >
                <dx-row-dragging
                    :on-drag-change="dragChange"
                    :on-reorder="dragReorder"
                    :allow-drop-inside-item="dragging?.allowDropInsideItem || false"
                    :allow-reordering="dragging?.allowReordering || false"
                    :show-drag-icons="dragging?.showDragIcons || false"
                />
                <dx-editing
                    mode="batch"
                    :allow-adding="editing?.allowAdding || false"
                    :allow-updating="editing?.allowUpdating || false"
                    :allow-deleting="editing?.allowDeleting || false"
                    :use-icons="editing?.useIcons || true"
                />
                <dx-column
                    v-for="(item, index) in meta.columns"
                    :key="index"
                    :caption="item.caption"
                    :data-field="item.dataField"
                    :visible="item.visible"
                    :cell-template="item.cellTemplate"
                    :edit-cell-template="item.editCellTemplate"
                    :editor-options="item.editorOptions"
                    :lookup="item.lookup || null"
                    :data-type="item.dataType || 'string'"
                    :calculate-cell-value="item.calculateCellValue"
                    :calculate-display-value="item.calculateDisplayValue"
                    :width="item.width"
                    :sort-index="item.sortIndex"
                    :sort-order="item.sortOrder"
                    :validation-rules="item.validationRules"
                    :allow-editing="item.allowEditing"
                />

                <dx-toolbar>
                    <slot name="toolbarItems"></slot>

                    <!-- <dx-item location="after">
                        <dx-button icon="expand" hint="Развернуть все" @click="expandAll" />
                    </dx-item>

                    <dx-item location="after">
                        <dx-button icon="collapse" hint="Свернуть все" @click="collapseAll" />
                    </dx-item> -->

                    <dx-item name="addRowButton" location="after" locate-in-menu="auto" />

                    <dx-item>
                        <dx-button
                            v-if="meta.enableDeleting"
                            icon="trash"
                            hint="Удалить"
                            :disabled="deleteButtonDisabled"
                            @click="onDeleteClick"
                        />
                    </dx-item>

                    <dx-item
                        name="revertButton"
                        location="after"
                        locate-in-menu="auto"
                        hint="Отменить все изменения"
                    >
                        <dx-button class="ai-button-base" hint="Выбор столбцов" @click="onRevertButtonClick">
                            <ai-revert-base />
                        </dx-button>
                    </dx-item>

                    <dx-item name="searchPanel" location="after" locate-in-menu="auto" />

                    <dx-item location="after" locate-in-menu="auto">
                        <dx-drop-down-button
                            icon='<svg width="79" height="79" viewBox="0 0 79 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M45.8581 4.08836C42.7691 -0.326979 36.2307 -0.326979 33.1418 4.08836L31.724 6.11496C29.8526 8.78982 26.5073 10.0074 23.3544 9.16124L20.9656 8.52012C15.7612 7.12333 10.7525 11.3261 11.2243 16.694L11.4409 19.1579C11.7267 22.4098 9.94669 25.4929 6.9875 26.8713L4.74549 27.9157C-0.139159 30.191 -1.27454 36.6301 2.53732 40.4388L4.28693 42.187C6.59621 44.4944 7.2144 48.0004 5.83357 50.9584L4.78739 53.1996C2.50808 58.0824 5.77728 63.7448 11.1456 64.2123L13.6096 64.4268C16.8617 64.71 19.5889 66.9984 20.4325 70.152L21.0717 72.5413C22.4642 77.7468 28.6083 79.9831 33.0211 76.8905L35.0466 75.471C37.7199 73.5975 41.28 73.5975 43.9533 75.471L45.9788 76.8905C50.3916 79.9831 56.5357 77.7468 57.9282 72.5413L58.5674 70.152C59.411 66.9984 62.1382 64.71 65.3903 64.4268L67.8543 64.2123C73.2226 63.7448 76.4918 58.0824 74.2125 53.1996L73.1663 50.9584C71.7855 48.0004 72.4037 44.4944 74.713 42.187L76.4626 40.4388C80.2744 36.6301 79.139 30.191 74.2544 27.9157L72.0124 26.8713C69.0532 25.4929 67.2732 22.4098 67.559 19.1579L67.7756 16.694C68.2474 11.3261 63.2387 7.12333 58.0343 8.52012L55.6455 9.16124C52.4926 10.0074 49.1473 8.78982 47.2759 6.11496L45.8581 4.08836ZM39.5 54.9611C47.4867 54.9611 53.9612 48.4866 53.9612 40.4999C53.9612 32.5132 47.4867 26.0386 39.5 26.0386C31.5133 26.0386 25.0388 32.5132 25.0388 40.4999C25.0388 48.4866 31.5133 54.9611 39.5 54.9611Z" fill="#286EB6"/>
                        </svg>'
                            styling-mode="text"
                            displayExpr="name"
                            hint="Пользовательские настройки"
                            :items="[
                                {
                                    id: 1,
                                    name: 'Настройки пользователя',
                                },
                                {
                                    id: 1,
                                    name: 'Заводские настройки',
                                },
                            ]"
                            :dropDownOptions="{ width: 230 }"
                        />
                    </dx-item>

                    <dx-item name="exportButton" location="after" locate-in-menu="auto" />

                    <dx-item name="columnChooserButton" location="after" locate-in-menu="auto">
                        <dx-button class="ai-button-base" hint="Выбор столбцов" @click="showColumnChooser">
                            <ai-show-column-chooser-base />
                        </dx-button>
                    </dx-item>
                </dx-toolbar>

                <template v-for="(_, name) in $slots" #[name]="obj">
                    <slot :name="name" :data="obj?.data" locate-in-menu="auto" />
                </template>
            </dx-tree-list>
        </div>
        <grid-footer ref="childRef" />
    </div>
</template>

<script setup>
import { DxTreeList, DxColumn, DxToolbar, DxEditing, DxItem, DxRowDragging } from 'devextreme-vue/tree-list';
import { onMounted, ref, computed } from 'vue';
import { DxButton } from 'devextreme-vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import gridFooter from './grid-footer.vue';

import onExporting from '@/utils/export-to-excel.js';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {
        },
    },
    dataSource: {
        type: Object,
        default: () => {
        },
    },
    editing: {
        type: Object,
        default: () => {
        },
    },
    dragging: {
        type: Object,
        default: () => {
        },
    },
});

const treeListRef = ref();
const treeListInstance = ref();
const expandedRowKeys = ref([]);
const childRef = ref();
const childInstance = ref();
const deleteButtonDisabled = ref(true);
const rowsPreparedToDelete = ref([]);
const datasrc = computed(() => {
    return props.dataSource;
});

onMounted(() => {
    treeListInstance.value = treeListRef.value.instance;
    childInstance.value = childRef.value;
});

const emit = defineEmits(['selectionChanged', 'dragChange']);

const addParentToExpanded = (row, currentExpandedRowKeys) => {
    if (row[props.meta.parentIdExpr]) {
        if (!currentExpandedRowKeys.includes(row[props.meta.parentIdExpr])) {
            currentExpandedRowKeys.push(row[props.meta.parentIdExpr]);
        }
        const parentRow = datasrc.value.find(item => item[props.meta.keyExpr] === row[props.meta.parentIdExpr]);
        if (parentRow) {
            addParentToExpanded(parentRow, currentExpandedRowKeys);
        }
    }
};

const showColumnChooser = () => {
    treeListInstance.value.showColumnChooser();
};

const selectionChanged = event => {
    emit('selectionChanged', event);
    childRef.value.selectRows(event.selectedRowKeys.length);
    let currentExpandedRowKeys = [...expandedRowKeys.value];

    if (props.meta.parentIdExpr && event.selectedRowKeys.length > 0) {
        event.selectedRowsData.forEach(row => {
            addParentToExpanded(row, currentExpandedRowKeys);
        });
    }

    setTimeout(() => {
        if (!isArraysEqual(expandedRowKeys.value, currentExpandedRowKeys)) {
            expandedRowKeys.value = currentExpandedRowKeys;
        }
    }, 0);

    deleteButtonDisabled.value = !event.selectedRowKeys.length;
};

const isArraysEqual = (array1, array2) =>
    array1.length === array2.length && array1.every((item, index) => item === array2[index]);

const onRevertButtonClick = () => {
    rowsPreparedToDelete.value = [];
};

const onRowPrepared = event => {
    if (event.rowType !== 'data') return;
    const parent = event.node.parent?.key;
    if (parent && rowsPreparedToDelete.value.includes(parent)) {
        event.rowElement.classList.add('dx-row-removed');
    }
};

const onDeleteClick = async () => {
    const selectedRows = treeListInstance.value.getSelectedRowKeys();

    selectedRows.forEach(key => {
        const index = treeListInstance.value.getRowIndexByKey(key);
        const node = treeListInstance.value.getNodeByKey(key);
        if (rowsPreparedToDelete.value.includes(key)) {
            treeListInstance.value.undeleteRow(index);
            rowsPreparedToDelete.value = rowsPreparedToDelete.value.filter(value => value !== key);
            removeClassesRecursively(node);
        } else {
            treeListInstance.value.deleteRow(index);
            rowsPreparedToDelete.value.push(key);
            addClassesRecursively(node);
        }
    });
    treeListInstance.value.clearSelection();
};

const removeClassesRecursively = node => {
    if (node.children.length > 0) {
        node.children.forEach(child => {
            if (rowsPreparedToDelete.value.includes(child.parent.key)) return;

            rowsPreparedToDelete.value = rowsPreparedToDelete.value.filter(value => value !== child.key);

            const childIndex = treeListInstance.value.getRowIndexByKey(child.key);
            const rowElement = treeListInstance.value.getRowElement(childIndex);
            if (childIndex > -1) rowElement[0].classList.remove('dx-row-removed');

            removeClassesRecursively(child);
        });
    }
};

const addClassesRecursively = node => {
    if (node.children.length > 0) {
        node.children.forEach(child => {
            rowsPreparedToDelete.value.push(child.key);

            const childIndex = treeListInstance.value.getRowIndexByKey(child.key);
            const rowElement = treeListInstance.value.getRowElement(childIndex);
            if (childIndex > -1) rowElement[0].classList.add('dx-row-removed');

            addClassesRecursively(child);
        });
    }
};

const contentReady = () => {
    childRef.value?.setTotalCount(treeListInstance.value.getVisibleRows().length);
};

const expandAll = () => {
    expandedRowKeys.value = datasrc.value.map(item => item[props.meta?.keyExpr]);
};

const collapseAll = () => {
    if (expandedRowKeys.value.length > 0) {
        expandedRowKeys.value = [];
    }
};

const dragChange = event => {
    emit('dragChange', event);
    const visibleRows = event.component.getVisibleRows();
    const sourceNode = event.component.getNodeByKey(event.itemData[props.meta.keyExpr]);
    let targetNode = visibleRows[event.toIndex].node;

    while (targetNode && targetNode.data) {
        // Если пытаемся узел на самого себя пихнуть, отменяем
        if (sourceNode.data[props.meta.keyExpr] === targetNode.data[props.meta.keyExpr]) {
            event.cancel = true;
            break;
        }
        //если находились на одном родителе и перемещаем на него же, только со сменой сортировки отменяем
        if (
            !event.dropInsideItem &&
            sourceNode.data[props.meta.parentIdExpr] === targetNode.data[props.meta.parentIdExpr]
        ) {
            event.cancel = true;
            break;
        }
        //если находились на родителе и на него же тащим, отменяем
        // неправильно срабатывает вырубил
        // if (event.dropInsideItem && sourceNode.data[props.meta.parentIdExpr] === targetNode.data[props.meta.keyExpr]) {
        //     event.cancel = true;
        //     break;
        // }
        targetNode = targetNode.parent;
    }
};

const dragReorder = event => {
    const visibleRows = event.component.getVisibleRows();
    if (event.dropInsideItem) {
        event.itemData[props.meta.parentIdExpr] = visibleRows[event.toIndex].key;
    } else {
        const sourceData = event.itemData;
        const toIndex = event.fromIndex > event.toIndex ? event.toIndex - 1 : event.toIndex;
        let targetData = toIndex >= 0 ? visibleRows[toIndex].node.data : null;
        if (targetData && event.component.isRowExpanded(targetData[props.meta.keyExpr])) {
            sourceData[props.meta.parentIdExpr] = targetData[props.meta.keyExpr];
            targetData = null;
        } else {
            sourceData[props.meta.parentIdExpr] = targetData ? targetData[props.meta.parentIdExpr] : -1;
        }
        const sourceIndex = datasrc.value.indexOf(sourceData);
        datasrc.value.splice(sourceIndex, 1);

        const targetIndex = datasrc.value.indexOf(targetData) + 1;
        datasrc.value.splice(targetIndex, 0, sourceData);
    }
    event.component.refresh();
};

defineExpose({
    treeListInstance,
    childInstance,
    expandAll,
    collapseAll,
});
</script>

<style lang="scss" scoped>
:deep(.dx-row-removed > td) {
    background-color: white;
    text-decoration: line-through;
}
</style>
